import { translate } from 'react-i18next';
export default translate;